import { HEADER_EDIT_BUTTON } from "./config/headerMenu.config";
import { DATA_MODEL_PROPERTY_LABEL_STYLE } from "./config/property.config";

export class ClassText {
    state = {};

    layout = {};

    style = {};

    txt;

    ctx;

    constructor(state, layout, style, ctx, txt) {
        this.state = { ...this.state, ...state };
        this.layout = { ...this.layout, ...layout };
        this.style = { ...this.style, ...style };
        this.txt = txt;
        this.ctx = ctx;
    }

    drawMultipleSections() {
        let currentTxtPrintingLength = 0;
        let hasEllipsis = false;
        const fillTextMaxWidth = this.layout.width - this.style.paddingLeft - (this.layout.height * 2 / 3) - this.style.paddingLeft / 2;
        for (let i = 0; i < this.txt.length; i++) {
            const section = this.txt[i];
            let font = [];
            font.push(section.fontWeight || 400);
            font.push(section.fontSize ? (`${section.fontSize}px`) : (`${DATA_MODEL_PROPERTY_LABEL_STYLE.fontSize}px`));
            font.push("Roboto");
            font = font.join(" ");
            const txt = this.fittingLabel(section.text, fillTextMaxWidth - currentTxtPrintingLength, this.ctx);

            if (txt.length > 2) {
                if (txt.indexOf("...") === txt.length - 3) {
                    hasEllipsis = true;
                }
            }
            this.ctx.textBaseline = this.style.textBaseline;
            this.ctx.textAlign = this.style.textAlign;
            this.ctx.font = font;
            this.ctx.fillStyle = section.fillStyle || (this.style[this.state.selected ? "selectedText" : "deselectedText"]);
            let labelX = this.layout.x + this.style.paddingLeft;
            const labelY = this.layout.y + this.layout.height / 2;
            labelX = this.style.textAlign === "center" ? (labelX + (this.layout.width / 2) - this.style.paddingLeft) : labelX;
            labelX += currentTxtPrintingLength;

            currentTxtPrintingLength += this.ctx.measureText(txt).width;

            if (this.txt) {
                this.ctx.fillText(txt, labelX, labelY);
            }

            if (hasEllipsis) {
                break;
            }
        }
    }
    /**
     * If i fits, i sits
     * *Insert cat meme here*
     */

    draw() {
        if (this.txt && Array.isArray(this.txt)) {
            this.drawMultipleSections();
            return;
        }
        this.ctx.textBaseline = this.style.textBaseline;
        this.ctx.textAlign = this.style.textAlign;
        const weight = this.style.fontWeight ? (`${this.style.fontWeight} `) : "";
        this.ctx.font = `${weight + this.style.fontSize}px Roboto`;
        this.ctx.fillStyle = this.style[this.state.selected ? "selectedText" : "deselectedText"];
        const fillTextMaxWidth = this.layout.width - this.style.paddingLeft - (this.layout.height * 2 / 3) - HEADER_EDIT_BUTTON.editWidth - this.style.paddingLeft / 2;
        let labelX = this.layout.x + this.style.paddingLeft;
        const labelY = this.layout.y + this.layout.height / 2;
        labelX = this.style.textAlign === "center" ? (labelX + (this.layout.width / 2) - this.style.paddingLeft) : labelX;

        if (this.txt) {
            this.ctx.fillText(this.fittingLabel(this.txt, fillTextMaxWidth, this.ctx), labelX, labelY);
        }
    }

    fittingLabel(label, maxWidth, ctx) {
        let { width } = ctx.measureText(label);
        const ellipsis = "…";
        const ellipsisWidth = ctx.measureText(ellipsis).width;
        if (width <= maxWidth || width <= ellipsisWidth) {
            return label;
        }
        let len = label.length;
        while (width >= maxWidth - ellipsisWidth && len-- > 0) {
            label = label.substring(0, len);
            width = ctx.measureText(label).width;
        }
        return label + ellipsis;
    }

    update(state, layout, style, txt) {
        if (state) this.state = { ...this.state, ...state };
        if (layout) this.layout = { ...this.layout, ...layout };
        if (style) this.style = style;
        if (txt !== null && txt !== undefined) this.txt = txt;
    }
}
